export class ReportCampaignConst {
  static displayColumns = () => {
    return [
      {
        title: 'STT',
        key: 'STT',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tên chuyên viên',
        key: 'name',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Tổng số cuộc gọi',
        key: 'total_call',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tổng thời gian tạm dừng',
        key: 'hold_total',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tổng thời gian hội thoại',
        key: 'talk_time',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Thời gian trung bình cuộc gọi',
        key: 'avg_duration',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
    ];
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/campaign/report/report.const.ts